import { render, staticRenderFns } from "./_base-nav-bar-simple.vue?vue&type=template&id=2c482c61&scoped=true&"
import script from "./_base-nav-bar-simple.vue?vue&type=script&lang=js&"
export * from "./_base-nav-bar-simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c482c61",
  null
  
)

export default component.exports